import { jsx as _jsx } from "react/jsx-runtime";
import { dialogClasses as muiDialogClasses } from '@mui/material';
import { forwardRef } from 'react';
import { MuiDialogStyled } from './Dialog.styled';
/**
 * Dialog.
 *
 * Disables close on *backdropClick* event.
 *
 * Additional properties: `fullHeight`.
 */
const Dialog = forwardRef(({ onClose, onClosed, onEnterSubmit, onKeyDown, ...props }, ref) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            // Is necessary in every `Enter` keydown event inside Dialog with ItemWorkflowSearchField on page. It prevents
            // `Enter` keydown event from firing in `useCatchWindowFocus` hook inside `ItemWorkflowSearchField` which leads to
            // following Enter keydown event on body element. That leads to a bug when, after Dialog (with
            // `disableRestoreFocus` prop) has been approved with Enter press, it then has been immediately reopened.
            event.stopPropagation();
            onEnterSubmit?.(event);
        }
    };
    // Should be extracted like this. Otherwise `onClose` wont fire on Escape key press, for some reason (occurred in
    // StockBlocked dialogs).
    const onKeyDownObject = onKeyDown ? { onKeyDown } : onEnterSubmit ? { onKeyDown: handleKeyDown } : {};
    return (_jsx(MuiDialogStyled, { ...props, ref: ref, onClose: (event, reason) => {
            if (reason === 'escapeKeyDown')
                onClose?.(event, reason);
        }, 
        /*
         * WARNING: Do not pass `onClosed` directly into `onExited` (e.g., `onExited: onClosed`), like this:
         * `slotProps={{ transition: { onExited: onClosed } }}`.
         * MUI passes the internal DOM element as the first argument to `onExited`. If `onClosed`
         * is bound directly to `react-hook-form`'s `reset` method, it will pass the DOM node
         * as the initial values object, severely corrupting the form state on subsequent opens.
         */
        slotProps: {
            transition: {
                onExited: () => onClosed?.(),
            },
        }, ...onKeyDownObject }));
});
export { Dialog };
export const dialogClasses = muiDialogClasses;
